// src/pages/Contact.jsx
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Se puede agregar un handler para evitar el comportamiento por defecto al enviar el formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí podrías agregar la lógica para enviar el mensaje vía una API o similar.
    alert("Tu mensaje ha sido enviado. ¡Gracias!");
  };

  return (
    <>
      <Header />
      <section className="hero-section inner-page" id="hero-contact">
        <div className="wave">
          <svg width="1920px" height="265px" viewBox="0 0 1920 265" xmlns="http://www.w3.org/2000/svg">
            <g fill="#FFFFFF">
              <path d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,667 L1017.15166,667 L0,667 L0,439.134243 Z"></path>
            </g>
          </svg>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="row justify-content-center">
                <div className="col-md-7 text-center hero-text" data-aos="fade-up">
                  <h1>Contáctanos</h1>
                  <p className="mb-5">
                    Estamos aquí para ayudarte. Escríbenos para cualquier consulta o soporte.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <main id="main">
        <section className="section">
          <div className="container">
            <div className="row mb-5 align-items-end" data-aos="fade-up">
              <div className="col-md-6">
                <h2>Formulario de Contacto</h2>
                <p className="mb-0">Déjanos tu mensaje y te responderemos a la brevedad.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 ms-auto order-2" data-aos="fade-up" data-aos-delay="100">
                <ul className="list-unstyled contact-info">
                  <li className="mb-3">
                    <strong className="d-block mb-1">Dirección</strong>
                    <span>Av. Ejemplo 123, Ciudad, País</span>
                  </li>
                  <li className="mb-3">
                    <strong className="d-block mb-1">Teléfono</strong>
                    <span>+1 232 3235 324</span>
                  </li>
                  <li className="mb-3">
                    <strong className="d-block mb-1">Email</strong>
                    <span>soporte@smartmoney.com</span>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 mb-5 mb-md-0" data-aos="fade-up" data-aos-delay="200">
                <form onSubmit={handleSubmit} className="php-email-form">
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label htmlFor="name">Nombre</label>
                      <input type="text" name="name" className="form-control" id="name" required />
                    </div>
                    <div className="col-md-6 form-group mt-3 mt-md-0">
                      <label htmlFor="email">Email</label>
                      <input type="email" className="form-control" name="email" id="email" required />
                    </div>
                    <div className="col-md-12 form-group mt-3">
                      <label htmlFor="subject">Asunto</label>
                      <input type="text" className="form-control" name="subject" id="subject" required />
                    </div>
                    <div className="col-md-12 form-group mt-3">
                      <label htmlFor="message">Mensaje</label>
                      <textarea className="form-control" name="message" id="message" rows="5" required></textarea>
                    </div>
                    <div className="col-md-12 mb-3">
                      <div className="loading">Cargando</div>
                      <div className="error-message"></div>
                      <div className="sent-message">Tu mensaje ha sido enviado. ¡Gracias!</div>
                    </div>
                    <div className="col-md-6 form-group">
                      <input type="submit" className="btn btn-primary d-block w-100" value="Enviar Mensaje" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <style jsx>{`
        .contact-info li {
          transition: transform 0.3s ease;
          cursor: pointer;
        }
        .contact-info li:hover {
          transform: translateX(5px);
        }
      `}</style>
    </>
  );
};

export default Contact;
